import React from 'react';
import clsx from 'clsx';

import { Grid, Box, Paper, useMediaQuery } from '@material-ui/core';
import { Button } from 'gatsby-theme-material-ui';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import Link from './Link';

const useStyles = makeStyles(theme => ({
  defaultStyle: {
    padding: theme.spacing(0),
  },
  minHeight: {
    height: theme.spacing(6),
  },
}));

const RichButton = ({ label, to, children, isBox = false, rowGrid = 6 }) => {
  const classes = useStyles();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isVerySmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
  let gridXs = rowGrid;
  if (isVerySmallScreen) { gridXs = 12; }
  if (isSmallScreen && !isVerySmallScreen) { gridXs = 6; }

  // <Button variant="contained" color="secondary">
  const content = (
    <Grid
      className={clsx(classes.defaultStyle, !children && classes.minHeight)}
      container
      spacing={0}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item container direction="column" alignItems="center" to={to} component={Link}>
        {label && (
          <Grid item>
            <Button variant="text" color="neutral">
              {label}
            </Button>
          </Grid>
        )}
        {children && (
          <Grid item>
            {children}
          </Grid>
        )}
      </Grid>
    </Grid>
  );

  const wrappedContent = isBox
    ? <Box> {content} </Box>
    : <Paper> {content} </Paper>;

  return (
    <Grid item xs={gridXs}>
      {wrappedContent}
    </Grid>
  );
};

export default RichButton;
